<div class="composer-message" *transloco="let t; read: 'emails'">
  <div class="question">
    <label>{{t('message')}}</label>
    <ckeditor [editor]="Editor" [(ngModel)]="model.editorData" (change)="onChanges()"></ckeditor>
  </div>
</div>
